import { LINKS } from "@/config/links";

const LEGACY_ONBOARDING_PATHS: string[] = [LINKS.ONBOARDING, LINKS.ONBOARDING_VERIFICATION];

// skipTrailingSlashRedirect leaves "/onboarding/verification/" unnormalized, so strip before matching the legacy list.
export function isApplicationOnboardingPath(pathname: string): boolean {
  const normalized = pathname.replace(/\/+$/, "") || "/";
  return normalized.startsWith(LINKS.ONBOARDING) && !LEGACY_ONBOARDING_PATHS.includes(normalized);
}
